export const DURATION_CYCLE = ["DAILY", "WEEKLY", "MONTHLY", "QUARTERLY", "SEMESTER", "ANNUALLY"];

export const ACCOUNT_TYPES_IE = {
  INTERNAL: "INTERNAL",
  EXTERNAL: "EXTERNAL",
} as const;

export const ACC_TYPE_IE_OPTIONS = [ACCOUNT_TYPES_IE.INTERNAL, ACCOUNT_TYPES_IE.EXTERNAL];
